import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { DeviceType, Orientation, Platform, WriteDirection } from 'sofa-reborn-react';

function getWidth(platform: Platform, deviceType: DeviceType, orientation: Orientation): string {
	if (platform === 'kiosk') {
		return `
			width: 550px;
		`;
	}

	return deviceType === 'mobile'
		? orientation === 'portrait'
			? `
					min-width: 240px;
			  `
			: `
					width: 422px;
			  `
		: `
				width: 384px;
		  `;
}

function getPaddingDescription(writeDirection: WriteDirection): string {
	if (writeDirection === 'ltr') {
		return `
			padding-right: 16px;
		`;
	}

	return `
		padding-left: 16px;
	`;
}

export const StyledSpan = styled.div<{
	color: string;
	borderColor: string;
	platform: Platform;
}>`
	${(props): string => `
		background-color: ${props.color};
		border-radius: 50%;
		display: inline-block;
		border: 2px solid ${SkapaTheme.color.neutral.white};

		&:not(.active) {
			height: ${props.platform === 'kiosk' ? '46px' : '34px'};
			width: ${props.platform === 'kiosk' ? '46px' : '34px'};
			border: ${props.borderColor ? '1px solid ' + props.borderColor : 'none'};
		}

		&.active {
			height: ${props.platform === 'kiosk' ? '38px' : '30px'};
			width: ${props.platform === 'kiosk' ? '38px' : '30px'};
			box-shadow: 0 0 0 2px ${SkapaTheme.color.semantic.informative};
		}
	`};
`;

export const LightboxContent = styled.div<{
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
}>`
	padding: 0 16px 16px 16px;
	${(props) => getWidth(props.platform, props.deviceType, props.orientation)}
`;

export const CoverPickerWrapper = styled.div<{
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
}>`
	overflow: ${(props) => (props.deviceType === 'mobile' ? 'visible' : 'auto')};
	[data-element-name='kompis-lightbox-header'] {
		${(props) => getWidth(props.platform, props.deviceType, props.orientation)}
	}
`;

export const CoversWrapper = styled.div<{
	missingCover: boolean;
}>`
	${(props): string => `
		display: flex;
		justify-content: center;
		border-bottom: 1px solid ${SkapaTheme.color.border.light};
		padding-bottom: ${props.missingCover ? '16px' : '8px'};

		.skipButton {
			position: absolute;
			left: 15px;
			top: 80px;
			opacity: 0;
			pointer-events: none;

			:focus {
				opacity: 1;
				pointer-events: auto;
			}
		}
	`}
`;

export const StyledCover = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
`;

export const StyledCoverHeader = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 16px 0;
`;

export const StyledNameIcon = styled.div`
	display: flex;
	flex-direction: column;
`;

export const EmptySpanWrapper = styled.div<{
	platform: Platform;
}>`
	height: ${(props) => (props.platform === 'kiosk' ? '62px' : '50px')};
	width: ${(props) => (props.platform === 'kiosk' ? '62px' : '50px')};
`;

export const StyledSpanWrapper = styled.div<{
	platform: Platform;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${(props) => (props.platform === 'kiosk' ? '62px' : '50px')};
	width: ${(props) => (props.platform === 'kiosk' ? '62px' : '50px')};
	cursor: pointer;

	&.focus-visible {
		/* !important used here to overwrite default Skapa outline */
		box-shadow: 0 0 0 ${SkapaTheme.focusOutline.width}px ${SkapaTheme.focusOutline.color} !important;
	}
`;

export const MissingCoverWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	border-bottom: 1px solid ${SkapaTheme.color.border.light};
	padding-bottom: 16px;
`;

export const SheetContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const DescriptionContainer = styled.div<{
	platform: Platform;
	deviceType: DeviceType;
	writeDirection: WriteDirection;
}>`
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
	${(props) => getPaddingDescription(props.writeDirection)}
`;

export const CoverDisclaimerWrapper = styled.div<{
	platform?: Platform;
}>`
	display: flex;
	justify-content: center;
	padding: 0 0 16px 0;
	max-width: ${(props) => (props.platform === 'kiosk' ? 'calc(100% - 80px)' : '100%')};
`;

export const CarouselContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const MediaWrapper = styled.div<{
	onlyOneImage: boolean;
}>`
	min-height: 500px;
	padding-bottom: ${(props) => (props.onlyOneImage ? '16px' : 0)};
`;

export const SkapaButtonWrapper = styled.div`
	button > span {
		box-sizing: border-box;
	}
`;
